import React, { useEffect } from 'react';
import { FormInputSelect } from '../../../common/formInputsV2/FormInputSelect';
import {
  GaranzieContainer,
  HeaderContainer,
  SectionContainer,
  GaranziaItem,
  GaranziaHeader,
  CheckboxWrapper,
  ParameterContainer,
} from './AncillariStepTwo.styles';

/**
 * Business Rules:
 * - is_required: Guarantee is mandatory and cannot be deselected (FUR and INC)
 * - excludes: Selecting this guarantee will automatically deselect these guarantees
 * - includes: Selecting this guarantee will automatically select these guarantees (and they become required)
 * - category: Used for UI grouping and organization
 */

const guaranteesAvailable = [
  {
    cod_garanzia: 'FUR',
    desc_garanzia: 'Furto',
    category: 'basic',
    is_required: true,
    excludes: [],
    includes: [],
    params: [],
  },
  {
    cod_garanzia: 'INC',
    desc_garanzia: 'Incendio',
    category: 'basic',
    is_required: true,
    excludes: [],
    includes: [],
    params: [],
  },
  {
    cod_garanzia: 'KSK',
    desc_garanzia: 'Kasko Completa',
    category: 'kasko',
    is_required: false,
    excludes: ['MNK'],
    includes: ['ATT', 'EV'],
    params: [],
  },
  {
    cod_garanzia: 'MNK',
    desc_garanzia: 'Mini Kasko',
    category: 'kasko',
    is_required: false,
    excludes: ['KSK'],
    includes: [],
    params: [],
  },
  {
    cod_garanzia: 'ASSG',
    desc_garanzia: 'Assistenza Gold',
    category: 'assistenza',
    is_required: false,
    excludes: ['ASS'],
    includes: [],
    params: [],
  },
  {
    cod_garanzia: 'ASS',
    desc_garanzia: 'Assistenza Silver',
    category: 'assistenza',
    is_required: false,
    excludes: ['ASSG'],
    includes: [],
    params: [],
  },
  {
    cod_garanzia: 'ATT',
    desc_garanzia: 'Eventi Socio Politici e Atti Vandalici',
    category: 'eventi',
    is_required: false,
    excludes: [],
    includes: ['EV'],
    params: [],
  },
  {
    cod_garanzia: 'EV',
    desc_garanzia: 'Eventi Naturali',
    category: 'eventi',
    is_required: false,
    excludes: [],
    includes: [],
    params: [],
  },
  {
    cod_garanzia: 'TLS',
    desc_garanzia: 'Tutela Legale Silver',
    category: 'tutela_legale',
    is_required: false,
    excludes: ['TLG'],
    includes: [],
    params: [
      {
        progressivo_parametro: 1,
        label: 'Massimale',
        options: [
          {
            value: '1',
            label: '€ 15.000',
          },
          {
            value: '2',
            label: '€ 25.000',
          },
        ],
      },
    ],
  },
  {
    cod_garanzia: 'TLG',
    desc_garanzia: 'Tutela Legale Gold',
    category: 'tutela_legale',
    is_required: false,
    excludes: ['TLS'],
    includes: [],
    params: [
      {
        progressivo_parametro: 1,
        label: 'Massimale',
        options: [
          {
            value: '1',
            label: '€ 15.000',
          },
          {
            value: '2',
            label: '€ 25.000',
          },
        ],
      },
    ],
  },
  {
    cod_garanzia: 'ICS',
    desc_garanzia: 'Infortuni del Conducente Silver',
    category: 'infortuni',
    is_required: false,
    excludes: ['ICG'],
    includes: [],
    params: [
      {
        progressivo_parametro: 1,
        label: 'Massimale',
        options: [
          {
            value: '1',
            label: '€ 25.000',
          },
          {
            value: '2',
            label: '€ 50.000',
          },
          {
            value: '3',
            label: '€ 75.000',
          },
          {
            value: '4',
            label: '€ 100.000',
          },
          {
            value: '5',
            label: '€ 200.000',
          },
        ],
      },
    ],
  },
  {
    cod_garanzia: 'ICG',
    desc_garanzia: 'Infortuni del Conducente Gold',
    category: 'infortuni',
    is_required: false,
    excludes: ['ICS'],
    includes: [],
    params: [
      {
        progressivo_parametro: 1,
        label: 'Massimale',
        options: [
          {
            value: '1',
            label: '€ 25.000',
          },
          {
            value: '2',
            label: '€ 50.000',
          },
          {
            value: '3',
            label: '€ 75.000',
          },
          {
            value: '4',
            label: '€ 100.000',
          },
          {
            value: '5',
            label: '€ 200.000',
          },
        ],
      },
    ],
  },
  {
    cod_garanzia: 'CRI',
    desc_garanzia: 'Cristalli',
    category: 'cristalli',
    is_required: false,
    excludes: [],
    includes: [],
    params: [
      {
        progressivo_parametro: 1,
        label: 'Massimale',
        options: [
          {
            value: '1',
            label: '€ 450',
          },
          {
            value: '2',
            label: '€ 600',
          },
          {
            value: '3',
            label: '€ 750',
          },
          {
            value: '4',
            label: '€ 1000',
          },
          {
            value: '5',
            label: '€ 1200',
          },
        ],
      },
      {
        progressivo_parametro: 2,
        label: 'Opzione',
        options: [
          {
            value: '1',
            label: 'SILVER',
          },
          {
            value: '2',
            label: 'GOLD',
          },
        ],
      },
    ],
  },
  {
    cod_garanzia: 'AC',
    desc_garanzia: 'Coperture Accessorie',
    category: 'accessorie',
    is_required: false,
    excludes: [],
    includes: [],
    params: [],
  },
];

function AncillariStepTwo({ fields, replace, update }) {
  // Initialize field array with guarantees
  useEffect(() => {
    if (fields.length === 0) {
      const initialGuarantees = guaranteesAvailable.map((g) => ({
        cod_garanzia: g.cod_garanzia,
        desc_garanzia: g.desc_garanzia,
        category: g.category,
        is_required: g.is_required,
        excludes: g.excludes,
        includes: g.includes,
        params: g.params,
        selected: g.is_required, // Required guarantees start selected
        parameterValues: {}, // Store parameter values
      }));
      replace(initialGuarantees);
    }
  }, [fields.length, replace]);

  // Check if a guarantee is disabled (required OR included by another selected guarantee)
  const isGuaranteeDisabled = (codGaranzia) => {
    const guarantee = fields.find((g) => g.cod_garanzia === codGaranzia);

    // Required guarantees are always disabled
    if (guarantee?.is_required) return true;

    // Check if this guarantee is included by any other selected guarantee
    return fields.some((g) => g.selected
      && g.includes?.includes(codGaranzia)
      && g.cod_garanzia !== codGaranzia);
  };

  // Handle checkbox change with business rules
  const handleCheckboxChange = (index) => {
    const guarantee = fields[index];

    // Don't allow toggling if disabled
    if (isGuaranteeDisabled(guarantee.cod_garanzia)) return;

    const newSelectedState = !guarantee.selected;

    // Update the clicked guarantee
    update(index, {
      ...guarantee,
      selected: newSelectedState,
      parameterValues: newSelectedState ? guarantee.parameterValues : {}, // Clear params if deselecting
    });

    if (newSelectedState) {
      // If selecting, handle includes and excludes

      // 1. Deselect excluded guarantees
      guarantee.excludes?.forEach((excludedCode) => {
        const excludedIndex = fields.findIndex((g) => g.cod_garanzia === excludedCode);
        if (excludedIndex !== -1) {
          update(excludedIndex, {
            ...fields[excludedIndex],
            selected: false,
            parameterValues: {}, // Clear parameters when deselecting
          });
        }
      });

      // 2. Auto-select included guarantees
      guarantee.includes?.forEach((includedCode) => {
        const includedIndex = fields.findIndex((g) => g.cod_garanzia === includedCode);
        if (includedIndex !== -1 && !fields[includedIndex].selected) {
          update(includedIndex, {
            ...fields[includedIndex],
            selected: true,
          });
        }
      });
    }
  };

  // Handle parameter change
  const handleParameterChange = (index, paramLabel, value) => {
    const guarantee = fields[index];
    update(index, {
      ...guarantee,
      parameterValues: {
        ...guarantee.parameterValues,
        [paramLabel]: value,
      },
    });
  };

  // Check if parameter has error (selected but no value)
  const hasParameterError = (guarantee, paramLabel) => guarantee.selected && !guarantee.parameterValues?.[paramLabel];

  return (
    <GaranzieContainer>
      <HeaderContainer>
        <h3>Garanzie Accessorie</h3>
      </HeaderContainer>

      <SectionContainer>
        {fields.map((guarantee, index) => {
          const hasErrors = guarantee.params?.some(
            (param) => hasParameterError(guarantee, param.label),
          );

          const isDisabled = isGuaranteeDisabled(guarantee.cod_garanzia);

          return (
            <GaranziaItem key={guarantee.id || guarantee.cod_garanzia} hasError={hasErrors}>
              <GaranziaHeader>
                <CheckboxWrapper>
                  <input
                    type="checkbox"
                    id={`garanzia-${guarantee.cod_garanzia}`}
                    checked={guarantee.selected || false}
                    onChange={() => handleCheckboxChange(index)}
                    disabled={isDisabled}
                  />
                  <label
                    htmlFor={`garanzia-${guarantee.cod_garanzia}`}
                    className={isDisabled ? 'disabled' : ''}
                  >
                    {guarantee.desc_garanzia}
                    {guarantee.is_required && ' (Obbligatoria)'}
                  </label>
                </CheckboxWrapper>
              </GaranziaHeader>

              {/* Render parameters if selected and has params */}
              {guarantee.selected && guarantee.params?.length > 0 && (
                <ParameterContainer>
                  {guarantee.params.map((param, paramIndex) => (
                    <FormInputSelect
                      key={`${guarantee.cod_garanzia}-param-${paramIndex}`}
                      label={param.label.toUpperCase()}
                      placeholder={`Seleziona ${param.label}`}
                      options={param.options.map((opt) => ({
                        id: opt.value,
                        name: opt.label,
                      }))}
                      value={guarantee.parameterValues?.[param.label] || ''}
                      onChange={(value) => handleParameterChange(index, param.label, value)}
                      error={
                        hasParameterError(guarantee, param.label)
                          ? 'Campo obbligatorio'
                          : ''
                      }
                      valid={
                        guarantee.selected && guarantee.parameterValues?.[param.label]
                      }
                    />
                  ))}
                </ParameterContainer>
              )}
            </GaranziaItem>
          );
        })}
      </SectionContainer>
    </GaranzieContainer>
  );
}

export default AncillariStepTwo;
